import { render, staticRenderFns } from "./material-maker.vue?vue&type=template&id=a0b78784&"
import script from "./material-maker.vue?vue&type=script&lang=js&"
export * from "./material-maker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports